export class EmailVerify {

    constructor(
        public icon: string = "close-circle",
        public message: string = "Errore durante la verifica della e-mail. Si prega di riprovare."){}
}

export const mapping : { [code: string]: EmailVerify } = {
    "defaultSuccess": new EmailVerify("check-circle", "Il tuo indirizzo e-mail è stato verificato con successo."),
    "defaultError": new EmailVerify(),
    "E037": new EmailVerify("mail","Il link utilizzato è scaduto. È stato inviato un nuovo link al tuo indirizzo e-mail."),
    "E039": new EmailVerify("close-circle","Il tuo indirizzo e-mail è già stato verificato.")
};
